
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[categoryOrPage]",
      function () {
        return require("private-next-pages/[categoryOrPage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[categoryOrPage]"])
      });
    }
  